import Vue from 'vue'
import toastr from '../toastr'
import VueMultiselect from 'vue-multiselect'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Singleselect from '../../component/singleselect.vue'
import Multiselect from '../../component/multiselect.vue'
import mixins from '../mixins.js'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

if ($('#verify_day_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#verify_day_form',
    components: {
      VueMultiselect,
      Singleselect,
      Multiselect,
      RingLoader,
      Datepicker,
      moment
    },
    mixins: [mixins],
    data: {
      loading: 0,
      dayId: null,
      brands: [],
      selectedBrand: null,

      selectedDate: null,
      newClientSelected: '00:00',
      regularClientSelected: '00:00',
      paymentToSelected: '00:00',
      menuChangeToSelected: '00:00',
      addressChangeToSelected: '00:00',
      mealResignationSelected: '00:00',
      mealBuySelected: '00:00',
      earlyDeliveryResignationSelected: '00:00',
      laterDeliveryResignationSelected: '00:00',
      menuRatingSelected: '00:00',
      backupOneSelected: '00:00',
      backupTwoSelected: '00:00',
      deliveryChangeDateSelected: '00:00',
      deliveryChangeDateOnThisDaySelected: '00:00',
      mealVisibilitySelected: '00:00',
      rateVisibilitySelected: '00:00',
      planMenuToSelected: '00:00',
      wmsOverProductionSelected: '00:00',
      resignElementToSelected: '00:00',
      addSimpleElementToSelected: '00:00',
      addElementFromWarehouseToSelected: '00:00',
      deliverySelected: null,
    },
    mounted() {
      this.loading++

      moment.locale('pl')

      this.getBrands()

      this.loading--
    },
    methods: {
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      changeTime() {
        this.calculateTime(this.newClientSelected, 'newClientDate')
        this.calculateTime(this.regularClientSelected, 'regularClientDate')
        this.calculateTime(this.paymentToSelected, 'paymentToDate')
        this.calculateTime(this.menuChangeToSelected, 'menuChangeToDate')
        this.calculateTime(this.addressChangeToSelected, 'addressChangeToDate')
        this.calculateTime(this.mealResignationSelected, 'mealResignationDate')
        this.calculateTime(this.mealBuySelected, 'mealBuyDate')
        this.calculateTime(this.earlyDeliveryResignationSelected, 'earlyDeliveryResignationDate')
        this.calculateTime(this.laterDeliveryResignationSelected, 'laterDeliveryResignationDate')
        this.calculateTime(this.menuRatingSelected, 'menuRatingDate')
        this.calculateTime(this.backupOneSelected, 'backupOneDate')
        this.calculateTime(this.backupTwoSelected, 'backupTwoDate')
        this.calculateTime(this.mealVisibilitySelected, 'mealVisibilityDate')
        this.calculateTime(this.rateVisibilitySelected, 'rateVisibilityDate')
        this.calculateTime(this.deliveryChangeDateSelected, 'deliveryChangeDateDate')
        this.calculateTime(this.deliveryChangeDateOnThisDaySelected, 'deliveryChangeDateOnThisDayDate')
        this.calculateTime(this.planMenuToSelected, 'planMenuToDate')
        this.calculateTime(this.wmsOverProductionSelected, 'wmsOverProductionDate')
        this.calculateTime(this.resignElementToSelected, 'resignElementToDate')
        this.calculateTime(this.addSimpleElementToSelected, 'addSimpleElementToDate')
        this.calculateTime(this.addElementFromWarehouseToSelected, 'addElementFromWarehouseToDate')
      },
      changeDeliveryDay() {
        let time = this.deliverySelected
        let date = moment.utc(this.selectedDate).subtract(time, 'days').format('YYYY-MM-DD dddd')

        $('#deliveryDate').html(date)
      },
      calculateTime(time, dateElement) {
        let dateToCheck = moment.utc(this.selectedDate).format('YYYY-MM-DD')
        let times = time.split(':')
        let date
        if (['menuRatingDate', 'rateVisibilityDate'].includes(dateElement)) {
          date = moment.utc(dateToCheck).add({
            hours: times[0],
            minutes: times[1]
          })
        } else {
          date = moment.utc(dateToCheck).subtract({
            hours: times[0],
            minutes: times[1]
          })
        }
        date = date.format('YYYY-MM-DD HH:mm dddd')

        $(`#${dateElement}`).html(date)
      },
      dateChangeEvent() {
        this.changeTime()
        this.changeDeliveryDay()
      },
      checkClick() {
        if (this.selectedBrand === null) {
          toastr.info('Proszę wybrać Markę')
          return
        }

        if (this.selectedDate === null) {
          toastr.info('Proszę wybrać Datę')
          return
        }

        let url = Routing.generate('api_get_days_day_to_verify')
        let data = {
          data: {
            date: moment.utc(this.selectedDate).format('YYYY-MM-DD'),
            brand: this.selectedBrand.id,
          }
        }

        this.loading++
        this.$http.post(url, data).then(response => {
          this.loading--

          this.clearData()

          if (!response.data.found) {
            toastr.info('Brak danych dla wybranego dnia/marki')
            return
          }

          $('#day').html(
            moment.utc(this.selectedDate).format('dddd')
          )

          let day = response.data.day
          // if (!response.data.isNonDefaultDay) {
          //     day = response.data.day[dayOfWeek];
          // }

          this.newClientSelected = day.newClient
          this.regularClientSelected = day.regularClient
          this.paymentToSelected = day.paymentTo
          this.menuChangeToSelected = day.menuChangeTo
          this.addressChangeToSelected = day.addressChangeTo
          this.mealResignationSelected = day.mealResignation
          this.mealBuySelected = day.mealBuy
          this.earlyDeliveryResignationSelected = day.earlyDeliveryResignation
          this.laterDeliveryResignationSelected = day.laterDeliveryResignation
          this.menuRatingSelected = day.menuRating
          this.backupOneSelected = day.backupOne
          this.backupTwoSelected = day.backupTwo
          this.deliverySelected = day.delivery
          this.mealVisibilitySelected = day.mealVisibility
          this.rateVisibilitySelected = day.rateVisibility
          this.deliveryChangeDateSelected = day.deliveryChangeDate
          this.deliveryChangeDateOnThisDaySelected = day.deliveryChangeDateOnThisDay
          this.planMenuToSelected = day.planMenuTo
          this.wmsOverProductionSelected = day.wmsOverProduction
          this.resignElementToSelected = day.resignElementTo
          this.addSimpleElementToSelected = day.addSimpleElementTo
          this.addElementFromWarehouseToSelected = day.addElementFromWarehouseTo

          $('#addressType').html(day.addressTypeName)
          if (day.description !== undefined) {
            $('#description').html(day.description)
          }

          this.dateChangeEvent()
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      clearData() {
        this.newClientSelected = '00:00'
        this.regularClientSelected = '00:00'
        this.paymentToSelected = '00:00'
        this.menuChangeToSelected = '00:00'
        this.addressChangeToSelected = '00:00'
        this.mealResignationSelected = '00:00'
        this.mealBuySelected = '00:00'
        this.earlyDeliveryResignationSelected = '00:00'
        this.laterDeliveryResignationSelected = '00:00'
        this.menuRatingSelected = '00:00'
        this.backupOneSelected = '00:00'
        this.backupTwoSelected = '00:00'
        this.mealVisibilitySelected = '00:00'
        this.rateVisibilitySelected = '00:00'
        this.deliveryChangeDateSelected = '00:00'
        this.deliveryChangeDateOnThisDaySelected = '00:00'
        this.deliverySelected = null
        this.planMenuToSelected = '00:00'
        this.wmsOverProductionSelected = '00:00'
        this.resignElementToSelected = '00:00'
        this.addSimpleElementToSelected = '00:00'
        this.addElementFromWarehouseToSelected = '00:00'

        $('#day').html('')
        $('#description').html('')
        $('#addressType').html('')

        $('#newClientDate').html('')
        $('#regularClientDate').html('')
        $('#paymentToDate').html('')
        $('#menuChangeToDate').html('')
        $('#addressChangeToDate').html('')
        $('#mealResignationDate').html('')
        $('#mealBuyDate').html('')
        $('#earlyDeliveryResignationDate').html('')
        $('#laterDeliveryResignationDate').html('')
        $('#menuRatingDate').html('')
        $('#backupOneDate').html('')
        $('#backupTwoDate').html('')
        $('#deliveryChangeDateDate').html('')
        $('#deliveryChangeDateOnThisDayDate').html('')
        $('#mealVisibilityDate').html('')
        $('#rateVisibilityDate').html('')
      }
    }
  })
}
